import { ToastContext, ToastTypeEnum } from "context/toastContext";
import Cookies from "js-cookie";
import { useContext, useState } from "react";

type CandidatesFileInput = {
  candidatesFile?: File;
};

interface UseUploadCandidatesProps {
  uploadUrl: string | ((id: string) => string);
}

const useUploadCandidates = ({ uploadUrl }: UseUploadCandidatesProps) => {
  const accessToken = Cookies.get("accessToken");
  const companyId = Cookies.get("companyId");
  const { addToast } = useContext(ToastContext);
  const [uploadCandidatesLoading, setUploadCandidatesLoading] = useState<boolean>(false);

  const uploadCandidates = async (
    formData: CandidatesFileInput & { examinationId?: string },
    onSuccess?: () => void
  ) => {
    if (!formData.candidatesFile) {
      // eslint-disable-next-line no-console
      console.log("Отсутствует файл");
      return;
    }
    if (typeof uploadUrl === "function" && !formData.examinationId) {
      addToast({ type: ToastTypeEnum.ERROR, text: "Ошибка при загрузке кандидатов" });
      // eslint-disable-next-line no-console
      console.log("Отсутствует id тестирования");
      return;
    }

    const uploadData = new FormData();
    uploadData.append("file", formData.candidatesFile);

    setUploadCandidatesLoading(true);
    const res = await fetch(
      // eslint-disable-next-line max-len
      `${process.env.REACT_APP_API_URL}/${typeof uploadUrl === "string" ? uploadUrl : uploadUrl(formData.examinationId as string)}`,
      {
        method: "POST",
        body: uploadData,
        headers: {
          Authorization: `JWT ${accessToken}`,
          ...(companyId && { "company-id": companyId }),
        },
      }
    )
      .then(async (response) => {
        if (!response.ok) {
          throw new Error();
        }

        addToast({ type: ToastTypeEnum.SUCCESS, text: "Кандидаты загружены" });
        if (onSuccess) onSuccess();
        return response;
      })
      .catch((err) => {
        addToast({ type: ToastTypeEnum.ERROR, text: "Ошибка при загрузке кандидатов" });
        // eslint-disable-next-line no-console
        console.log(err);
      })
      .finally(() => setUploadCandidatesLoading(false));

    // eslint-disable-next-line consistent-return
    return res;
  };

  return { uploadCandidatesLoading, uploadCandidates };
};

export default useUploadCandidates;
